<div class="wrapper">
    <div class="left-side">
        <hamburger-menu></hamburger-menu>
    </div>

    <div class="right-side">
        <user-info-dialog></user-info-dialog>
    </div>
</div>

<div class="info">
    <div class="icon-alert"></div>
    <h2>Vi kan ikke finne siden du er ute etter</h2>
    <div>Bruk globalmenyen oppe til venstre for nytt valg eller</div>
    <div>gå til <a href="https://home.eiendomsverdi.no/">forsiden.</a> For support, kontakt</div>
    <div><a [href]="'mailto:' + support.email">{{ support.email }}</a></div>
    <div>eller ring {{ support.phone }}</div>
</div>